<template>
  <div v-if="$store.state.errorSnackbar">
    <div v-if="$store.state.errorSnackbar.show">
      <v-snackbar v-model="$store.state.errorSnackbar.show" :timeout="15000" multi-line top color="red">
        <v-icon class="mr-3">warning</v-icon>
        <span v-html="$store.state.errorSnackbar.message"></span>
        <v-btn @click.native="clearError()" dark flat icon>
          <v-icon>close</v-icon>
        </v-btn>
      </v-snackbar>
    </div>
  </div>
</template>

<script>
  import store from '@/store/store';
  export default {
    methods: {
      clearError: () => {
        store.commit('errorsModule/HANDLE_ERROR', { show: false, message: '' });
      },
    },
  };
</script>
